import { useDynamicEntity } from './useDynamicEntity';

export const useFirmCards = (hookConfig = null) => {
  const config = hookConfig || {};
  const dynamicHook = useDynamicEntity({
    entityType: 'firm_cards',
    gqlEntityKey: 'firm_carts',
    queryName: 'GET_FIRM_CARDS_QUERY',
    createMutation: 'CREATE_FIRM_CARD_MUTATION',
    updateMutation: 'UPDATE_FIRM_CARD_MUTATION',
    deleteMutation: 'DELETE_FIRM_CARD_MUTATION',
    mutationPattern: 'default',
    createVariableName: 'object',
    updateVariableName: 'set',
    customWhereCondition: config.firm_id ? { firm_id: config.firm_id } : null,
    transformData: firmCard => {
      return {
        ...firmCard,
        fullName: `${firmCard.firm_cart_firstname || ''} ${firmCard.firm_cart_lastname || ''}`.trim(),
        statusText: firmCard.firm_cart_status ? 'Aktif' : 'Pasif',
      };
    },
    transformFormData: formData => {
      return {
        firm_id: formData.firm_id,
        firm_cart_firstname: formData.firm_cart_firstname,
        firm_cart_lastname: formData.firm_cart_lastname,
        firm_cart_mail: formData.firm_cart_mail,
        firm_cart_phone: formData.firm_cart_phone,
        firm_cart_second_phone: formData.firm_cart_second_phone,
        firm_cart_title: formData.firm_cart_title,
        firm_cart_status: formData.firm_cart_status === 'yes' || formData.firm_cart_status === true,
      };
    },

  });

  return {
    ...dynamicHook,
  };
}; 